module.exports = __webpack_public_path__ + "media/media/favicon/android-chrome-192x192-0a07c6b2a654865ad25319e6854f0829.png";